import { http } from './http';
import type {
  DayNote,
  Item,
  CreateItemRequest,
  UpdateItemRequest,
} from '@daynote/shared-types';

export const daynoteApi = {
  getByMonth: (month: string) =>
    http.get<unknown, { dayNotes: DayNote[]; locked?: boolean }>('/daynotes', {
      params: { month },
    }),

  getByDate: (date: string) =>
    http.get<unknown, { dayNote: DayNote | null }>(`/daynotes/${date}`),

  createItem: (date: string, data: CreateItemRequest) =>
    http.post<unknown, Item>(`/daynotes/${date}/items`, data),

  updateItem: (itemId: string, data: UpdateItemRequest) =>
    http.patch<unknown, Item>(`/items/${itemId}`, data),

  deleteItem: (itemId: string) => http.delete(`/items/${itemId}`),

  updateOrder: (dayNoteId: string, itemIds: string[]) =>
    http.patch(`/daynotes/${dayNoteId}/order`, { itemIds }),
};
